import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
  },
  textButtonWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
});
